var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomecoverhero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 318.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #225866;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #a02e44;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #6097b2;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #0c476b;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #ff8b66;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #8bbddb;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #adbec4;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #164353;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #db614d;\r\n      }\r\n\r\n      .st9 {\r\n        fill: #3e6575;\r\n      }\r\n\r\n      .st10 {\r\n        fill: #662c33;\r\n      }\r\n\r\n      .st11 {\r\n        fill: #f24052;\r\n      }\r\n\r\n      .st12 {\r\n        fill: #ef6e4b;\r\n      }\r\n\r\n      .st13 {\r\n        fill: #205260;\r\n      }\r\n\r\n      .st14 {\r\n        fill: #cfd8dc;\r\n      }\r\n\r\n      .st15 {\r\n        fill: #ce364c;\r\n      }\r\n\r\n      .st16 {\r\n        fill: #8b383e;\r\n      }\r\n\r\n      .st17 {\r\n        fill: #1a4850;\r\n      }\r\n\r\n      .st18 {\r\n        fill: #ffb878;\r\n      }\r\n\r\n      .st19 {\r\n        fill: #105e99;\r\n      }\r\n\r\n      .st20 {\r\n        fill: #0e3944;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M110.8,318.7h-55.1c-1,0-1.8-.8-1.8-1.8v-1c0-1,.8-1.8,1.8-1.8h55.1c1,0,1.8.8,1.8,1.8v1c0,1-.8,1.8-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M459.9,318.7h-15.1c-1,0-1.8-.8-1.8-1.8v-1c0-1,.8-1.8,1.8-1.8h15.1c1,0,1.8.8,1.8,1.8v1c0,1-.8,1.8-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M214.5,318.7h-55.1c-1,0-1.8-.8-1.8-1.8v-1c0-1,.8-1.8,1.8-1.8h55.1c1,0,1.8.8,1.8,1.8v1c0,1-.8,1.8-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.4,318.7h-55.1c-1,0-1.8-.8-1.8-1.8v-1c0-1,.8-1.8,1.8-1.8h55.1c1,0,1.8.8,1.8,1.8v1c0,1-.8,1.8-1.8,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.5,318.7h-75.1c-1,0-1.8-.8-1.8-1.8v-1c0-1,.8-1.8,1.8-1.8h75.1c1,0,1.8.8,1.8,1.8v1c0,1-.8,1.8-1.8,1.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M129.3,68.4s-5.8-4-14.3-.9c-8.5,3.1-10.4,14.5-8.3,23.8s-9.6,41.1-9.6,41.1c0,0,6.1,8.6,27.4,5.3,0,0,15.9-28.8,14.7-49.6s-9.8-19.7-9.8-19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M136,104.2c8-2.6,12.9,4.1,17.5,16.5s6.1,13.6,6.1,13.6l17.7,11.4-1.5,6.6s-16.8-6.6-20.9-10.8c-4.1-4.2-15.8-25.4-15.8-25.4l-3.1-11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97,184.3s-3.5,17.6-2.9,44c0,0-13.7,20.2-2.4,77.7h5.9s4.8-49,8.5-62.2c3.7-13.3,17.4-17.3,18.1-57.7l-27.3-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.9,236c-3.4-11.3-12.3-30.3-35-56.1,0,0-1.4-.7-3.2.4-1.9,1.2-1.9,2.6-1.9,2.6,0,0,11.4,24.8,18.6,43,2.4,6.1,8.3,10.1,14.9,10.1h6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.2,257.9s0,8.5-5.5,8.6c-7.8.2-8.1-8.3-17-8-8.9.3-27.2,2.5-33-11.4-3-7.2,1.1-16.4-8.6-23.3-9.7-6.9-5-14.7,0-18.9,5-4.2-2.2-8.7,3.1-10.8,1.2-.5,2.5-.4,3.6,0,.7.2,1.3.6,1.9,1,2.8,1.8,4.7,5,4.7,5,14.7-40.3,40.9-45.6,40.9-45.6l25.9,8.9c.6,62.7-15.9,94.6-15.9,94.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M136,104.2s-6,2-14.6.7c-8.6-1.3-11.4-6.7-17.4-3.2-9.1,5.2-4.8,23.2-2.5,32.5.8,3.5,1.9,12.6-.1,20.2,0,0,12.1,9.4,25.9,8.9l7.5-16.4s16.4-19.6,1.3-42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.6,89.2s1,8.5-2.1,16.2c0,0,4.5,6.6,8.8,2.3,0,0,.4-7.8,5.2-16.6,3.2-5.9-11.8-1.9-11.8-1.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.8,89.4s-3.8-2.4-3.4,1.3c.5,4.3,4.7,5.1,5.1,3.6.4-1.5-1.8-4.9-1.8-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.5,84.8s2.4-3.8,3.6-.3c1.4,4.1-2,6.6-3.1,5.5-1-1.2-.5-5.2-.5-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M127.6,102.2c-6.9,1.5-11.7-2.1-14.7-15.5-1.6-6.9,1-12,8.7-13.7,7.7-1.7,11.9,1.8,13.4,8.7,3.2,14.4-.3,18.9-7.4,20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M133.8,87.1c.3.7-.2,1.5-1,1.8-.8.3-1.7,0-2-.6-.3-.7.2-1.5,1-1.8.8-.3,1.7,0,2,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.8,90.6c.1.7-.5,1.4-1.4,1.5-.9.1-1.7-.3-1.8-1s.5-1.4,1.4-1.5c.9-.1,1.7.3,1.8,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M129.1,80.8c0,0-.1,0-.2,0-1.2-.8-2.8-.4-2.9-.4-.2,0-.4,0-.4-.3,0-.2,0-.4.3-.4,0,0,2-.5,3.4.5.2.1.2.3,0,.5,0,.1-.2.2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M116.1,83.7c0,0-.1,0-.2,0-.2-.1-.2-.3-.1-.5.9-1.5,2.8-1.9,2.9-1.9.2,0,.4,0,.4.3,0,.2,0,.4-.3.4,0,0-1.7.3-2.4,1.5,0,.1-.2.2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M129.4,84.6c.2.9,0,1.6-.5,1.7-.5.1-1-.5-1.2-1.4s0-1.6.5-1.7c.5-.1,1,.5,1.2,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M119.8,86.6c.2.9,0,1.6-.5,1.7-.5.1-1-.5-1.2-1.4s0-1.6.5-1.7c.5-.1,1,.5,1.2,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M122.9,94.7s4.4-.4,6.3-2c0,0-.5,3.4-2.9,3.7-2.4.2-3.4-1.7-3.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M127,84.7s.2-2.2,1-2.3c.9,0,1.9,1.6,1.9,1.6l1.1-.9-1.2.4s-1.1-1.7-1.9-1.6c-1.2.3-.9,2.7-.9,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M120.4,86.4s-1.1-2-1.9-1.6-1,2.3-1,2.3l-1.4-.4h1.3c0-.1.2-2.1,1-2.3,1.2-.3,2,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M125.1,90.7l-.4-.7c.6-.3.6-.7.6-1,0-.4-.4-.7-.7-.7-.1,0-.3.1-.3.4l-.7-.3c.3-.8.9-.9,1.1-.8.6,0,1.2.6,1.3,1.3.2.7-.2,1.4-1,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M114.3,91.9s-2.1-7.8-.9-13.3c0,0,6-8.3,17.5-4.2,0,0,3.4,5.5,5.1,13.2,0,0,.4-2.8-.7-8.9-1.1-6.2-6.6-10-14.1-8.8-7.5,1.2-15.5,8.7-6.9,22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M126.4,72.6s.5,2-1.5,7.3c0,0-1.4-1.5-3.1,0s-5,1-6.2,1.8-1.2,2.6-1.2,2.6c0,0-1-2.3,0-5,0,0-2.2,2.9-1.9,6.4,0,0-3-.5-2.9-5.5.1-5,7.3-13.2,15.3-12.6,8,.5,9.9,13.2,9.9,13.2,0,0-.7-.6-1.9-.3,0,0-.2-2.7-2-6.1,0,0,.8,2.4,0,5.1,0,0-2.2-1.2-4-.8,0,0,1.1-2.1-.6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.9,103.3c3.9-3.1,6.9.8,7.7,6.2.7,5.4-6.3,37.3-11.8,36.2-2.1-.5-3-8.8-3-8.8,0,0,2.1-9,3.5-22.5.6-6.2,1.5-9.5,3.5-11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.5,141.2c-5.3-5-14.7-21.6-17.1-30.1l4-1.6s12,17.2,17.5,21.5c5.5,4.3,7.4,9.2,5,13.3-2.4,4.1-8.2-2.1-9.3-3.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.1,100.1c-.3,5.4,4.2,6.7,2.2,10.9-.4.9-1,1.3-1.7,1.5-1.2.4-2.6,0-3.5-.9-2.1-2.1-5.4-4.4-7.1-5.4-2-1.1-.9-1.4-.9-1.4-.2,0-.4-.2-.6-.2-1.4-.6-2.5-.8-1.5-1.4,1.1-.7,5.2.8,5.2.8-5.3-3.5-6.7-2.7-5.8-3.4,1.3-1,6.3,1.3,6.5,1.4-2.8-2.6-4.8-3.2-3.7-3.6,1.1-.4,6.7,3.6,8.7,5.1.5.3.7.6.7.6,0-4.4,1.3-3.8,1.3-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73,103.3c.5.3.7.6.7.6,0,0-.9,1.6.3,3.7,0,0-2.2-1.5-1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M68.4,106.5c-.5-.3-3.1-1.8-4.2-1.7-.2,0-.4-.2-.6-.2.7-.9,4.2,1.5,4.8,1.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.4,187c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.4,194.4c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.6,198.3c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.7,173.1c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 102.2,
    cy: 183.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.2,189c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.5,171.5c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 110.4,
    cy: 167.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.9,207.9c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.7,203.3c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1c.6,0,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.6,195c-.2.3-.5.5-.9.5-.6,0-1.1-.5-1.1-1.1s0-.3,0-.4c.7.2,1.3.6,1.9,1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 84.3,
    cy: 221.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.1,236.9c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 68.2,
    cy: 227.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 51.5,
    cy: 219.6,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66,251.6c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.2,195.4c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1c.6,0,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.4,177.5c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98,162.5c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1c.6,0,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.5,184.3c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.5,166.8c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.1,214.9c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1c.6,0,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.7,205.5c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 91.5,
    cy: 202.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 113.6,
    cy: 207.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.6,177.5c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.4,179.7c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.8,215.9c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 90.4,
    cy: 234.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 74,
    cy: 238,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 119.1,
    cy: 221.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.4,229.9c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.2,253.7c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1c.6,0,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 98.6,
    cy: 248.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 114.5,
    cy: 241.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.4,260.2c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107.2,316.4h-17.5c-1.1-3.3,1-6.5.6-9.4-.6-4.9,2.2-2.2,2.2-2.2.5-5.2,7.8-6.2,7.8-3.9-.1,3.4.5,5.6,1.5,7,2,2.9,5.2,2.8,5.8,4.9,0,.2,0,.4.1.6.5,2.6-.5,3.1-.5,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M107.7,313.4c-3.6.8-12-.3-12.3-2.4-.3-2,4.2-3,6.4-3.1,2,2.9,5.2,2.8,5.8,4.9,0,.2.1.4.1.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M35.2,180.6c-1.9-1.7-4.9,1.1-4.9,1.1,0,0,1.6,2.4.6,3.4s-2.3-1.3-4.4-.3c-.2,0-.3.2-.5.3-1.6,1-3.3,3-4.7,4.5-.3.3-.5.6-.8.9-1.6,1.7-5.7,2.6-6.5-1.8-.8-4.4,4.2-9.6,9.7-14.4s9-1.9,9-1.9c0,0,1.2,2,1.2,3.3s1.1,1.9,1.7,3.1c.6,1.2-.6,1.9-.6,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M26,185.1c-1.6,1-3.3,3-4.7,4.5-2.1.5-3.9.3-4.2-1.6-.7-4.7,8.6-10.6,7.9-7.3-.4,1.6.3,3.2,1,4.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M350.6,308.8c-.9-.5-1.7-1.5-2.4-2.7,0,0-.6-3.7,0-7.7.6-3.9-1.1-7.1-6.6-8.3-5.4-1.2-8.6,1.4-7.4,12.3,0,0,0,0,0,0-.8,4.5-1,9.7.9,14h16.6s2.6-5.6-1.1-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.2,250.4s0,10.8-6.1,21.9c-6.2,11.3-13.9,26.8-13.9,26.8,0,0-5.1,5-8.4-3.3,0,0,2.3-28.8,7.6-39.4,5.3-10.5,20.8-6.1,20.8-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M444.9,215.1s9.9,41.6,16.2,52.6c0,0-1.4,4.6-8.3,6,0,0-21.5-31.6-22.9-45-1.4-13.3,15-13.6,15-13.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M449.6,224.9c-2.6,6.3-23,6.7-23,6.7l-1.6-2.3-.4-.6-3.2-4.7s-33.7-33-40.2-30.3h0c-.2,0-.4.2-.6.3-4.5,3.2-4.9,20.9-10.3,50.5-.5,2.8-1.6,6.1-2.5,8.3-.1.2-.2.5-.3.7-.5,1.3-.8,2.1-.8,2.1-20.6,8.3-27.3-8.1-27.3-8.1,0,0,.2-.5.6-1.2,0-.2.2-.4.3-.6,1.1-2.4,2.8-6.5,2.8-8.7,0-2.4,0-4.7,0-6.9,0-.2,0-.4,0-.6,0-7.1,0-13.3,0-18.7v-.6c0-2.3,0-4.5.1-6.6v-.6c.2-9.4.5-15.6.8-19.8,0-.2,0-.4,0-.6.6-7,1.2-7.7,1.2-7.7l-4.1-28.6h44.9s6.8,6.8,15.5,15.7c.2.2.4.4.5.5,3.2,3.2,6.6,6.7,10,10.3.1.1.3.3.4.4,1.4,1.4,2.7,2.8,4.1,4.2.2.2.3.3.5.5,4.5,4.7,8.9,9.3,12.6,13.3.1.1.3.3.4.4,5.1,5.5,9,10,10.4,12,3.6,5.5,6.3,12.5,7.9,16.9h0c0,.2.1.4.2.6.7,2.1,1.1,3.5,1.1,3.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M351.9,179.4c-1.8,2.2-4.5,3.5-7.9,4,0-.2,0-.4,0-.6,3.2-.5,5.8-1.7,7.5-3.8,3.1-3.6,2.6-8.6,2.6-8.6h.6c0,.1.5,5.1-2.7,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M402.1,162.7c-.2,0-.3,0-.5,0-5,0-10.2-5.5-10.5-5.7l.4-.4c0,0,5.3,5.5,10.1,5.6.2.2.4.4.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M368,252.9c-.1.2-.2.5-.3.7-3.3,1.2-6.4,1.7-9.2,1.7-8.9,0-15-5.1-18.4-9,0-.2.2-.4.3-.6,4.3,5.1,13.5,12.5,27.6,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M380,183.4c.7,3.2,1.2,6.7,1.2,10.3-.2,0-.4.2-.6.3,0-16.8-9.7-29.8-9.8-30l.4-.3c0,.1,5.8,7.9,8.6,19.1,1.1-.7,1.9-1.8,2.2-3.2,1.4-5.9-5-15.5-5-15.6l.5-.3c.3.4,6.6,9.9,5.1,16-.4,1.6-1.3,2.8-2.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M430.1,191.9c-1.7,1.8-3.2,3.3-3.4,3.5l-.3.3v-.4c-2.3-5.7-16.3-18-16.5-18.2l-.2-.2,2.3-3.9c.1.1.3.3.4.4l-2,3.2c2.7.9,4.7,1.1,6,.9.2.2.3.3.5.5-.5,0-.9.1-1.5.1-1.3,0-2.7-.3-4.3-.7,3.2,2.9,13,12,15.3,17.1.9-.9,2-2,3.1-3.2.1.1.3.3.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M353.3,230h-.2c-.2.1-2.7.6-5.6.6s-3-.1-4.4-.5c0-.2,0-.4,0-.6,3.7,1.1,8.6.2,9.7,0l-.9-23.1c-.5,1.3-1.6,3-3.5,4-.9.5-2,.7-3.1.7s-1.4,0-2.1-.2v-.6c1.9.4,3.6.3,5-.4,2.4-1.2,3.3-3.7,3.6-4.7-1.9.3-5.6-.7-8.4-1.5v-.6c3.1.9,7.2,2,8.7,1.5h.4c0-.1,1,25.4,1,25.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M448.5,221.4c-3.2,3.2-9.8,8.1-20,8.1s-2.2,0-3.4-.2l-.4-.6c12.4,1.4,20.1-4.4,23.6-7.9,0,.2.1.4.2.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M394.3,24.8s-1.2-2.8-6.5-2.8c-4,0-5.6,2.2-5.6,2.2-2.4,7-5,34-5.9,34.9-.5.5-30.3,20.6-30.3,20.6,16.2.3,26.3,20.3,26.3,20.3.5-6.6,18.8-32.5,19-34.9.4-4.4,8.1-23.9,2.9-40.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M342.6,165.5s-.1,5.6,1.7,6,16.6,4.7,33.6-3c17-7.7,20-13.5,15-17.7-5-4.3-50.3,14.7-50.3,14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M335.7,83.5s-15.5-1.8-24.4,2c0,0-2.5,11,9.7,35.6,12.2,24.6,9.4,40.1,23.1,45.9,12.2,5.2,48.2-10.2,49.3-15.3,2.8-12.8-19.2-35.4-20.5-48.5-1.4-13.1-14.2-32.7-37.2-19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M311.4,85.5c-10.8,3.8-23,16-23,21.9s10.2,8.1,10.2,8.1l16.7-8.1s4.8-3.3,1.7-13c-3-9.7-5.6-8.8-5.6-8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M355.8,96.4c-3.2,0-7.2-1.2-9.7-2.9-1.4-1-2.2-2.1-2.4-3.2-.6-3.8,3.1-5.8,3.3-5.9l.5,1c-.1,0-3.2,1.7-2.7,4.7.1.8.8,1.7,1.9,2.5,2.8,2,7.6,3.2,10.8,2.6,1.4-.2,2.3-.8,2.8-1.5.5-.9,0-2,0-2l1-.4c0,0,.6,1.5-.1,2.9-.6,1.1-1.8,1.8-3.5,2.1-.6.1-1.2.2-1.9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M342.1,108.1c-2.4,0-6.4-1-6.9-4.9-.3-2-.1-3.7,0-5.1.2-2.2.4-3.9-.8-5.9-2.1-3.4-4.9-3.6-5-3.6v-1.1c.2,0,3.6.2,6,4.1,1.5,2.4,1.2,4.4,1,6.6-.2,1.5-.3,3,0,4.9.6,4.2,6,4,6.2,4v1.1c0,0-.2,0-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M345.5,88.2s8.2-5.6,6.2-11.6-28.3-5.6-35.1,1.6c-6.8,7.2,14.7,12,14.7,12,1.7-3.4,12.3-3.7,14.2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.8,87.2c-3.9-1.3-6.2-4.1-5.4-7.4.8-3.2,17.5-3.3,20.7-.7,3.2,2.6-1.3,12.9-15.3,8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M328.9,78.1s3.4,5.9,1.8,9.1c0,0,11.8,4.1,11.8-2.5,0,0-2.2-4.9-1.4-8.1l-12.3,1.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M325,73s-5.8-9.3-5.3-18.1c.3-4.4,2.5-6.2,2.5-6.2,0,0-1.8-2.6.1-6.5,0,0,2.7,3.2,12.3,2.2,9.2-1,10.2,5.6,10.2,5.6,6.6,1,2.1,21-2.5,23h-17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M322.5,64.4s-3.3-3.3-3.7.6c-.5,4.5,3.6,6.3,4.4,4.9.8-1.4-.7-5.4-.7-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M345.8,64.6s3.3-3.3,3.7.6c.5,4.5-3.6,6.3-4.4,4.9-.8-1.4.7-5.4.7-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.8,80.7c-7.4,0-11.6-4.8-11.6-19.3s3.8-12,12.1-12,11.8,4.6,11.8,12c0,15.6-4.6,19.3-12.3,19.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M343.7,66.6c.1.7-.5,1.5-1.4,1.6-.9.2-1.8-.3-1.9-1.1-.1-.7.5-1.5,1.4-1.6.9-.2,1.8.3,1.9,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M328.5,67c0,.8-.9,1.3-1.8,1.3-.9,0-1.7-.7-1.6-1.5,0-.8.9-1.3,1.8-1.3.9,0,1.7.7,1.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M340.4,58.8c0,0-.2,0-.3,0-1.2-.9-2.9-.6-3-.6-.2,0-.4,0-.4-.3,0-.2,0-.4.3-.4,0,0,2.1-.4,3.6.7.2.1.2.4,0,.5,0,0-.1.1-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M326.3,58.9c0,0-.2,0-.2-.1-.1-.2-.1-.4,0-.5,1.4-1.1,3.5-.8,3.5-.8.2,0,.3.2.3.4,0,.2-.2.3-.4.3,0,0-1.8-.3-2.9.7,0,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M339.6,63c0,.9-.4,1.7-.9,1.7-.5,0-.9-.7-.9-1.7s.4-1.7.9-1.7.9.7.9,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M329.8,63c0,.9-.4,1.7-.9,1.7-.5,0-.9-.7-.9-1.7s.4-1.7.9-1.7.9.7.9,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M324.5,51s7.9,2.9,19.2,2.1c0,0,2.4,3,2.1,13.6,0,0,6.6-19.1-12.7-19.1s-10.6,18.6-10.6,18.6c0,0-1.6-11.7,2-15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M334.3,67.9l-.6-.6,1.5-1.5c-1.4-2-1.4-6.6-1.4-6.8h.8c0,0,0,5,1.4,6.6l.3.3-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M329.4,70.3s7.3.3,10.9-.7c0,0,.6,5.3-5,5.6-6,.3-6-4.9-6-4.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M360.5,90.3c1.4-.3,1.2,3.4,0,2.3-1.2-1.1-1.4-2.1,0-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M343.7,107.9c-.2,1.4-3.6,0-2.2-.8,1.4-.8,2.4-.6,2.2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M328.8,115.5s-2.2,5.7-2.1,8.8,1.2,2.8,1.2,2.8c0,0-1.7.7-2,2.5-.3,1.8,4.3,3.2,4.6,3.2s3.6-1.2,3.6-1.2l.7-10.4-2.9-1.8-3.1-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.6,114.8s4,2.5,5.6,4c1.6,1.5.7,13.3,0,13.9-.7.6-5.8,1.7-6.8,1.1s.4-4.1.4-4.1c0,0,2.6-.6,2.2.4-.4,1,0,1.8,0,1.8l1.1-.4s-.5-2.6,0-4.6c.5-1.9-3.6-4-4.1-7.5-.5-3.6,1.7-4.5,1.7-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M289,109c-1.3-5.5,4.2-7.5,11.9-6.6,8.9,1.1,27.1,3.4,31.1,13,0,0,1.3,3.8-2.1,5.6-9.4,5.1-38.5-1.7-40.9-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.8,105.4s-10.6-4.4-15.9-4.8c-5.3-.4,7.3,4.2,15.9,4.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M396.1,10c-.8.9-2.1,4.5-2.1,4.5-.6,3-.9,4.6-1.9,6-1,1.4-.5,3.8-.5,3.8,0,0-4,2.1-7.4-.5,0,0,.4-2.4,0-3.1-.7-1.4-2.9-2.1-3.7-4.8-.8-2.7-3.1-5.8-3.1-5.8,0,0,.7-1.4,1.9-.6,1.2.9,2,3.1,2.6,3.3.1,0,.3,0,.4,0,0,0,0,0,0,0,.5,0,1,0,1.3-.3,0,0,0,0,0,0,1.1-1.3,1.4-5,1.3-6.7,0-2.3,0-5.6,1.4-5,1.4.5.1,1.8,1.2,7h.5c.1.4,1.1-3.1,1.3-6.3.2-2.3,1.6-1.4,2-.7.3.7-.2,3-.3,4.6,0,1.1-.2,2.2-.2,2.9l.6.3c2.2-3.9,1.5-5.5,2.8-5.6,1.3,0,.8,3.2.1,4.5-.3.5-.6,1.7-.8,2.8,2.3-2.7,2-4,3.1-3.9,1.1.2.1,2.8-.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M386.2,16.2c-.8-2.1-3.6-3.1-3.9-3.2.5,0,1,0,1.3-.3,2.7,1.2,2.6,3.6,2.6,3.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M338,300.1s-1.5-3.1-.2-4.5c1.4-1.3,3,1.2,5.3.6,2.3-.6,2.9-2.2,3.5,0,.6,2.3-.1,9.4-8.6,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M346.8,300s-6.3,2.2-9.5,0l.8,2.7s6.8.7,7.8-1l.9-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M346.7,303.4s-5.8-.8-8.5.6v1.3s7.5-1.8,9.9,0l-1.4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M337.9,308.2s1.1-2.7,4.6-2.9,5.9,1.7,5.9,1.7c0,0-5.6-2.3-10.5,1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M486,270.4c-11,14.7-26.1,17.6-26.1,17.6-4.4-3.5-4.5-7.6-4.5-7.6,0,0-4.2-3.8-4.8-5.6-.6-1.8,3.6-7.2,6.1-6.7,1.7.4,2.7,1.8,3.2,2.6-2.1-4.7-.4-6.3,2.5-5.9,3.1.4.2,1.1,2.4,3.6.2.2.3.3.5.5.4.3.9.5,1.4.6.5,0,1,.1,1.6,0,.3,0,.6,0,.9,0,.6,0,1.1-.2,1.7-.4.9-.3,1.9-.7,2.8-1.2,3.8-2.1,5.4-2.8,8.3-2.1,2.9.7,2.9,2.9,2.9,2.9l1,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M486,270.4c-11,14.7-26.1,17.6-26.1,17.6,7.7-3.3,14.7-7.6,19.5-12.9,4.8-5.3,6.5-4.6,6.5-4.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M465.4,268.9c.4.3.9.5,1.4.6-2.9.6-3.1,3.2-3.1,3.2l-1.2-.4c.3-3.1,2.7-3.4,3-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M467.3,272.9h-1.3c-.5-1.8.1-2.9.8-3.5.5,0,1,.1,1.6,0-1.5,1.5-1,3.4-1,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M470.5,272.2l-1.3.2c-.5-1.3-.4-2.3,0-3,.6,0,1.1-.2,1.7-.4-1.1,1.6-.4,3.2-.4,3.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M346.9,135.3s2.9,15.4-2.9,21.5c-5.8,6.1-2,1.1-.2-6.8,1.7-7.9.4-16.2,3.1-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M373.5,128.4s9.1,3,13.8,11.4c0,0-6.3-13.7-13.8-11.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.5,14.1c1.2,0,4.7,1.4,4.7,1.4,2.6,1.6,4,2.5,5.7,2.6,1.7.2,2.4,3.1,2.4,3.1,0,0,6.7,1.5,7.1-2.8,0,0-3.8-5.3-4-6-.5-1.4.4-3.6-1.1-6-1.5-2.4-2.2-6.2-2.2-6.2,0,0-1.5-.5-1.7,1-.2,1.5.9,3.5.7,4.2,0,.1-.1.2-.2.4,0,0,0,0,0,0-.3.4-.7.7-1.1.7,0,0,0,0-.1,0-1.7,0-4.6-2.4-5.8-3.5-1.7-1.6-4.1-3.7-4.7-2.3-.6,1.4,1.3,1.3,4.4,5.6l-.3.4c.2.3-3-1.3-5.6-3.3-1.8-1.4-2.2.3-1.8,1,.3.7,2.3,1.9,3.6,2.9.9.7,1.7,1.4,2.3,1.8l-.2.7c-4.4-1-5.1-2.6-6-1.7-.9.9,1.8,2.8,3.2,3.1.6.1,1.6.7,2.6,1.3-3.5,0-4.4-1.2-5-.3-.6.9,2,2,3.2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M148.7,10.9c-1.1-2,0-4.7.2-5.1-.3.4-.7.7-1.1.7-.9,2.8.9,4.3.9,4.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.3,14.1c-1.2,0-4.7,1.4-4.7,1.4-2.6,1.6-4,2.5-5.7,2.6-1.7.2-2.4,3.1-2.4,3.1,0,0-6.7,1.5-7.1-2.8,0,0,3.8-5.3,4-6,.5-1.4-.4-3.6,1.1-6,1.5-2.4,2.2-6.2,2.2-6.2,0,0,1.5-.5,1.7,1,.2,1.5-.9,3.5-.7,4.2,0,.1.1.2.2.4,0,0,0,0,0,0,.3.4.7.7,1.1.7,0,0,0,0,.1,0,1.7,0,4.6-2.4,5.9-3.5,1.7-1.6,4.1-3.7,4.7-2.3.6,1.4-1.3,1.3-4.4,5.6l.3.4c-.2.3,3-1.3,5.6-3.3,1.8-1.4,2.2.3,1.8,1-.3.7-2.3,1.9-3.6,2.9-.9.7-1.7,1.4-2.3,1.8l.2.7c4.4-1,5.1-2.6,6-1.7.9.9-1.8,2.8-3.2,3.1-.6.1-1.6.7-2.6,1.3,3.5,0,4.4-1.2,5-.3.6.9-2,2-3.2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M324.1,10.9c1.1-2,0-4.7-.2-5.1.3.4.7.7,1.1.7.9,2.8-.9,4.3-.9,4.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M276.2,218l-12.9-80-25.9,2.9-25.9-2.9-12.9,80-6.2,77.6s2,6.4,14.9,2c0,0,9.6-72,11.1-73.5s16.7-48.6,16.7-48.6h4.8s15.2,47,16.7,48.6c1.5,1.6,11.1,73.5,11.1,73.5,12.9,4.4,14.9-2,14.9-2l-6.2-77.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M229.3,60.5c1.6,1.6,9.7,4.5,13.9,0l2.9,2.8s-3.3,7.7-9,8c-5.8.3-9.9-6.9-9.9-6.9l2.2-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M252.1,59.7c9.6-4.1,40.7-15.2,40.7-15.2,0,0,20.9-26.2,25.2-30.1,0,0,4.6.8,6,6.6,0,0-13.5,28.8-20.8,37.1-7.3,8.2-44.4,26.1-44.4,26.1l-6.7-24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M218.4,59.1c2.9-1.8,17.2,7.8,17.2,7.8,0,0,18.7-9.9,23.1-8,0,0,4,5.3,5.5,18.9,1.6,13.6,1.7,69.5,1.7,69.5,0,0-12.6,4.4-29.6,4.4s-29.8-5.6-29.8-5.6c0,0-3.5-77.5,11.8-87.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M230.1,57.6s2.1,6.5,0,9c0,0,2.1,4.5,6,4.7,4.5.2,6-4.7,6-4.7,0,0-2.4-6.3,0-8.5l-12-.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M224.9,51.2s-4.4-8.4-3.5-17.3c.9-9,14.4-11,23.5-6.6,0,0-2.7-2.6-1.6-3.4,1.1-.7,2.9,4,2.9,4,0,0,2.9-.9,3.3,0,.4.9-2.9,1.4-2.9,1.4,0,0,5.9,3.3.4,20.6l-22,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.2,45.9s-3.2-3.2-3.6.5c-.5,4.4,3.5,6.2,4.3,4.8.8-1.4-.7-5.3-.7-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M247,46.1s3.2-3.2,3.6.5c.5,4.4-3.5,6.2-4.3,4.8-.8-1.4.7-5.3.7-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.3,61.8c-7.2,0-11.3-4.7-11.3-18.8s3.7-11.7,11.8-11.7,11.5,4.5,11.5,11.7c0,15.2-4.5,18.8-12,18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M244.9,48c.1.7-.5,1.4-1.4,1.6s-1.7-.3-1.9-1c-.1-.7.5-1.4,1.4-1.6.9-.2,1.7.3,1.9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M230,48.4c0,.7-.8,1.3-1.7,1.2-.9,0-1.6-.7-1.6-1.4,0-.7.8-1.3,1.7-1.2.9,0,1.6.7,1.6,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M241.6,40.7c0,0-.2,0-.3-.1-1-1-2.7-1-2.8-1-.2,0-.4-.1-.4-.3,0-.2.1-.4.3-.4,0,0,2.1,0,3.3,1.2.1.1.1.4,0,.5,0,0-.2,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M228,40.7c0,0-.2,0-.2,0-.1-.1-.1-.4,0-.5,1.2-1.3,3.2-1.2,3.3-1.2.2,0,.4.2.3.4,0,.2-.2.4-.4.3,0,0-1.8,0-2.8,1,0,0-.2.1-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M240.9,44.5c0,.9-.4,1.6-.9,1.6s-.9-.7-.9-1.6.4-1.6.9-1.6.9.7.9,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M231.3,44.5c0,.9-.4,1.6-.9,1.6s-.9-.7-.9-1.6.4-1.6.9-1.6.9.7.9,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M231.3,54.1s6.4.8,9.6-.8c0,0-1.8,4.3-5.3,3.9-3.5-.4-4.3-3.2-4.3-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M246.5,47.7s-.2-7.8-3.3-13.9c0,0-5.4,2.5-6.6,1.9-1.2-.6,1.1-1.9,1.1-1.9,0,0-8.9,2.9-9.4,2.3-.5-.6,2.9-2.3,2.9-2.3l-5.5,1.9s-1.7,7.1-1,12c0,0-2.4-4.1-2.7-6.9s1-10.9,9.3-11.5c8.3-.6,13,1.3,15.1,5.1,2.1,3.8,1.8,8.5,0,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M236.5,51.8c-.7,0-1.4-.2-1.6-.2l.2-.7c.8.2,1.9.3,2.2,0,0-.1,0-.4,0-.7-1-2.2-1.3-7.8-1.3-8.1h.8s.2,5.7,1.2,7.7c.3.6.3,1.1,0,1.5-.3.4-.8.5-1.4.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M244.5,62.6s13,40.5,14.3,73.4c0,0,4.7,1.3,10-5.9,5.3-7.2,2.1-64.4-8-73.9,0,0-4.6-1.1-16.3,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M246.6,69.7s2.3-5.4,1.3-9.1-4.7,0-4.7,0c0,0,1.5,6.1,3.4,9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M220.4,59.7c-9.6-4.1-40.7-15.2-40.7-15.2,0,0-21-26.9-25.2-30.8,0,0-5.3,3-5.6,9.2,0,0,13.2,27,20.5,35.3,7.3,8.2,44.4,26.1,44.4,26.1l6.7-24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M228,62.6s-13,40.5-14.3,73.4c0,0-4.7,1.3-10-5.9-5.3-7.2-2.1-64.4,8-73.9,0,0,4.6-1.1,16.3,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.9,69.7s-2.3-5.4-1.3-9.1,4.7,0,4.7,0c0,0-1.5,6.1-3.4,9.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M293.9,316.4h-25.9c-1.8-10.3,1.1-20.6,1.1-20.6l11.8-2c1.1,6.5,2.4,9.1,4.2,10.4h0c1.3,1,2.9,1.3,4.8,1.9,2.2.8,3.4,2.2,4,3.7,1.2,3,0,6.6,0,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M294,309.9c-6.4.8-20.4,2.2-19.6-1.5.7-3.1,6.6-3.9,10.7-4.1h0c1.3,1,2.9,1.3,4.8,1.9,2.2.8,3.4,2.2,4,3.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M207.2,316.4h-25.9s-.8-2.4-.4-5c.3-2.1,1.4-4.3,4.4-5.3,2.2-.8,4-1.1,5.4-2.4,1.5-1.4,2.7-4.1,3.6-9.9l11.8,2s2.9,10.3,1.1,20.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M180.9,311.4c.3-2.1,1.4-4.3,4.4-5.3,2.2-.8,4-1.1,5.4-2.4,3.3,1,7.9,2.9,9.3,5.7,2,3.9-13.2,3.2-19.1,2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.1,314.6c0,1.1-.1,1.9-.1,1.9h-31.5c0-.6,0-1.2,0-1.9.4-8.2,3-15.4,3-15.4l7.9-3.4c.7,4.1,2.4,6.6,4.6,8.3.6.5,1.2.8,1.8,1.2.3.2.6.3.9.4.7.3,1.3.5,2,.7,2.8.8,5.6,1,7.5,1.3,3.4.5,3.9,4.4,3.9,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.1,314.6c0,1.1-.1,1.9-.1,1.9h-31.5c0-.6,0-1.2,0-1.9h31.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.8,305.3l-4.4,1.4-.9-1.6,3.5-1c.6.5,1.2.8,1.8,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.7,306.5l-2.9,2-1.8-.7,2.7-2c.7.3,1.3.5,2,.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.9,314.6c0,1.1-.4,1.9-.4,1.9h-20.9c-.3-.6-.5-1.2-.6-1.9-2.1-10,11.9-22.3,11.9-22.3l4.4,5.9s-.5,9.4,3.2,11.4c2.2,1.2,2.5,3.4,2.4,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251,314.6h21.9c0,1.1-.4,1.9-.4,1.9h-20.9c-.3-.6-.5-1.2-.6-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.6,308.8s-8.8-2-12.9.6v-1.5s7.4-3.6,12.9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.8,306.6s-5.6-2.6-11.1,0l.6-1.5s6.5-2.5,10.5,1.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M383.6,225.4c0,8.4-7.5,77.1-7.5,77.1-7.5.7-13.5-.8-13.5-.8-2.1-34.8-2.3-64.8-2.3-64.8l-35.9-26.9h0c0,0-.1.5-.4,1.6-1.8,7.9-9.3,40.9-12.4,48.5-3.6,8.6-42.5,44.8-42.5,44.8-7.2-1-13.4-6.2-13.4-6.2,14-23.2,33.1-46.5,33.1-46.5,1.5-8.4,2.6-27,3.2-40.9,0-.2,0-.4,0-.6.4-9.4.6-16.5.6-16.5l-6.6-13.5,41.8-15.3,9.4,12s2.1,2,5.5,5.2c.2.1.3.3.5.4,12.5,11.8,40.4,38.5,40.4,42.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292,211.5c0-.2,0-.4,0-.6,8.8-4.8,7.3-12.4,7.3-12.5h.5s1.6,8.1-7.9,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M323.9,204.8c.3,1.7.5,3.5.6,5.4h0c0,0-.1.5-.4,1.6-.4-13.1-5.8-20.8-5.8-20.9l.5-.3c0,0,3.5,5,5.1,13.5,6.4-5.6.1-17.2,0-17.3l.5-.3c0,.1,6.7,12.4-.4,18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.2,183.1s0,0,0,0c-.3.1-.6.1-.9.1-3.1,0-8.2-4.3-8.5-4.5l.4-.4c1.7,1.4,6.4,4.8,8.6,4.3.2.1.3.3.5.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289,109s12.7-2,19.1,2,14.7,14.6,14.7,14.6c0,0-9.9,1.3-11,8,0,0-7.2-17.2-22.7-24.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M269.9,115.7c-5.4,2.9-14.4,13.8-14.8,20.5-.4,6.5,4.4,12.6,7.7,17.7,10.2,16,20.9,30.1,25.5,48.8,0,.1,23.3,9.4,50.6-23.5,0,0-15.4-20.8-20.8-38.5-2.2-7.2-4.4-14.8-8.6-21.2-4.6-7-12.5-11.1-20.6-10.4-6.9.6-13.8,3.8-19.1,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M267.6,109s3.4,5.9,1.8,9.1c0,0,11.8,4.1,11.8-2.5,0,0-2.2-4.9-1.4-8.1l-12.3,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M293.9,149.2s-6.6,1.9-8.2,4.2-3.1,7.5-3.1,7.5h11.3l2.1-3.9,2.5-5.2-4.6-2.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M283,102.4s4.6-1.9,1.6-15.8c-2-9.2-4.8-10.5-6.7-10.6,0,0-2.2-3.4-10-1.8-5.3,1.1-9.6,4.4-11.5,10.4-2,6.3,2,19.7,7.1,21l19.4-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M284.1,93s2.9-4,4,0c1.3,4.6-2.7,7.2-3.8,5.9-1.1-1.4-.2-5.8-.2-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M259.8,97.3s-4-2.9-3.8,1.2c.3,4.8,4.9,6,5.4,4.3.6-1.6-1.6-5.6-1.6-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.1,112c7.7-1.3,11.2-7,8.7-22.1-1.3-7.8-6-11.9-14.7-10.5-8.6,1.4-11.5,6.8-10.2,14.6,2.7,16.2,8.2,19.3,16.1,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M262.4,98.9c0,.8.8,1.5,1.8,1.5,1,0,1.8-.6,1.8-1.4s-.8-1.5-1.8-1.5c-1,0-1.8.6-1.8,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M278.3,96.8c.2.8,1.1,1.2,2.1,1,1-.2,1.6-1,1.4-1.8-.2-.8-1.1-1.2-2.1-1-1,.2-1.6,1-1.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M264.6,90.5c0,0-.2,0-.2,0-.2-.1-.2-.4-.1-.5,1.1-1.6,3.2-1.9,3.3-1.9.2,0,.4.1.4.3,0,.2-.1.4-.3.4,0,0-1.9.3-2.8,1.6,0,.1-.2.2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M279.1,88.1c0,0-.2,0-.2,0-1.2-.9-3.1-.6-3.1-.6-.2,0-.4,0-.5-.3,0-.2,0-.4.3-.5,0,0,2.2-.4,3.8.7.2.1.2.4,0,.5,0,.1-.2.2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M266,94.5c.2,1,.7,1.7,1.2,1.6.5,0,.8-.9.7-1.9s-.7-1.7-1.2-1.6c-.5,0-.8.9-.7,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M276.3,92.8c.2,1,.7,1.7,1.2,1.6.5,0,.8-.9.7-1.9s-.7-1.7-1.2-1.6-.8.9-.7,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M279.2,101.5s-6.7,1.8-10.4,1.1c0,0,2.6,3.2,6.2,2.3,3.7-.9,4.2-3.4,4.2-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M279.5,82.9s-8.7,6.3-19.6,6.8l.3,9.7s-10.2-18.8,10-22.1c20.1-3.3,14.3,17.6,14.3,17.6,0,0-.6-9-4.9-12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M272.4,98.9v-.8s1.1,0,1.4-.8c.1-.3-.4-1.2-.8-2.1-.6-1.2-1.4-2.6-1.7-4.2l.8-.2c.3,1.5,1,2.9,1.6,4,.6,1.2,1.1,2.1.8,2.8-.5,1.2-2.1,1.3-2.2,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M284.2,82.9c-14.6-6.4-28.4,6.8-28.4,6.8,0,0-1.6-10.7,1.2-13.2.7-.7,1.5-1.2,2.3-1.7,6.5-4.1,15.1-4,19-2.6.8.3,1.4.6,1.8,1,2.3,2.4,4.1,9.7,4.1,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M282.4,80.5s-12.3-2.4-23.7,5.2c0,0-.7-6.9.6-10.9,6.5-4.1,15.1-4,19-2.6,2.3,2.6,4.1,8.3,4.1,8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257,88.5s1.9-8.3,4.6-10.6c4.4-3.9,16.6-5.2,23.1-2.9s0,9.4,0,9.4c0,0-10.3-7.4-27.7,4.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M276,143.4s5,7.8,13.6,12.4c0,0,10.7-9.3,24.6-8.5,0,0-11.5,20.7-21.4,23-5.2,1.2-24-11.2-24-11.2,0,0,3.7-13.2,7.2-15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M257.5,129.3c4.6-7.5,15.2,3.6,18.8,11.5,3.6,7.9,6.2,9.6,6.2,9.6,0,0-10.6,4.4-10.5,12.4,0,0-24.6-17.1-14.5-33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M289.5,152.4s6.5-6.3,27.7-14.6l-2.7-8.6c2.4-3.2,6.9-3.2,6.9-3.2,0,0,10.9,15.4,9,19.9-1.2,2.9-23.8,5.9-40.8,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.8,139.9s.2-.9,1-2c.8-1.1.6-3.1.9-3.7.3-.6,2-3.2,3.1-3.7,1.1-.5,2.6-1.3,2.9,0,.3,1.4-2,1-3,3,0,0,2.3-.7,4-.3s2.3,2.1,0,2c-1.8,0-4,1.2-4,1.2,0,0,2.3.3,1.9,1.4-.5,1.5-3.3.6-6.7,2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.8,168.8c1.9,4.9,9.7,13.2,9.7,13.2,0,0,19-11.4,27.7-6.6,8.8,4.8,15.7,7.7,21.4,5.6,5.7-2.1-18.7-46.4-18.7-46.4l-31.6-12.1s-.7,8-4.3,9.4-7.5,14.6-7.2,17.1c.3,2.5,2.9,19.7,2.9,19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.3,182.2s-8.1,16-25,36.4c0,0-1.7,24.3-46.2,62.6l-4.7-3.7s26.5-41.5,31.8-54.2c5.3-12.7-2.9-24.4,21.4-56.5l22.6,15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M165.4,154c-7,13.4-9.4,30.6-9.4,30.6l-3.2,8.1s11.3,6.1,24.4,8.3l5.2-13.9-17.1-33.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202,181s3.5,17.6,2.9,44c0,0,13.7,20.2,2.4,77.7h-5.9s-4.8-49-8.5-62.2c-3.7-13.3-17.4-17.3-18.1-57.7l27.3-1.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M205.5,199.8s-11.1,2-30.8,1.1l-.3-2.2v-.6c0,0-2.1-14.3-2.1-14.3,0,0-1.9-2.3-3.8-6.1-.2-.4-.5-.9-.7-1.4-2.6-5.6-5-13.8-2.4-22.3l4.1.2h.6s13.9.7,13.9.7h.6s4.6.2,4.6.2h.7s3,.2,3,.2c0,0,15,13.5,12.3,38.5l.2,3.5v.6s.1,2.1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M170.1,154.2c-.4,1.1-3,9.6-1.7,23.5-.2-.4-.5-.9-.7-1.4-1-12.7,1.3-20.6,1.8-22.2,0-.2.1-.3.1-.3l.5.2s0,0,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M205.4,197.8c-3.9,1-10.6,1.3-17,1.3s-11.1-.2-14-.4v-.6c4.9.2,18,.8,26.5-.2l-.5-8.9c.1-10.4-3-19.3-6.1-25.5-7.7-1.4-9.8-7.1-10.3-8.7,0-.3-.1-.4-.1-.4h.5c0,0,0,.1.1.5.5,1.7,2.6,6.6,9.4,8-2.1-4-4-6.8-4.8-7.8-.2-.3-.4-.5-.4-.5l.4-.4s.3.3.7.9c2.6,3.5,11.3,16.7,11,33.9l.5,8.9c1.5-.2,2.8-.4,3.9-.7v.6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177,93.8c-4.4-2.4-36.3,10.1-36.3,10.1,0,0-4.7,8.4-1.8,11.7s13.4,1.8,16.5,0,11.6-3.2,11.6-3.2l9.8-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M205.1,67.2s6.6,2.5,9,10.1c2.4,7.6-4.8,26.8-2.3,35.6s2.1,25.5-5.7,29c-7.8,3.5-23.7-2.8-27.1-12.4-3.4-9.6-1.9-46.1,4.6-58.5,6.6-12.4,19.9-6.2,21.5-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.6,99.9c1.7,1.9,6.2-1.5,6.2-1.5,0,0,0,16.5-4.9,17.8-4.8,1.3-17.1-13-16.6-16.9.5-3.9,11.4-3.6,15.3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M179.1,95.8s4.9,4.1,13.3,6.1c8.5,2,13.1-2,17.4,3.4,6.5,8.2-4.1,23.3-9.6,31.1-2.1,2.9-6.5,11-7.3,18.8,0,0-14.7,4.3-27.4-1.3l-.9-18s-8-24.3,14.6-40.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.3,113.3s6.7-16,8.7-17c1.9-1,6.9,1.4,7.9,3.6,1,2.2,0,7,0,7,0,0-5.3-6-16.5,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.4,181c-3.1,6.3-10.5,8-10.5,8,0,0-.6-.9-1.5-2.4-.1-.2-.2-.3-.3-.5-5.9-9.6-23.9-40.1-23.6-56.1.4-19,12.8-29.4,12.8-29.4,6.3,1.5,8.3,3.2,8.3,3.2,0,0,2.1,10.8.2,23.8-1.9,13-5.5,16.4-3.7,17.4,1.8,1,0,2.9,0,2.9,0,0,10.4,14.6,12.4,19.1,1.3,3,3.4,8,4.8,11.1,0,.2.2.4.3.6.6,1.3.9,2.2.9,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M208.3,103.8s-7.5,5.5-3.1,14l20.7,21.5c-11.4,12.1-12.5,17.1-20.7,22.7l3.1,4.8s28.8-22.1,28.9-27.5c0-2.3-17.6-30.2-28.9-35.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.7,162s-4,.4-6.4,1.1c-2.5.6-5.8,1.2-5.9,1.8-.1.5,5.5,0,5.5,0,0,0-4.6,1.9-4.7,2.6s5.8-.5,5.8-.5c0,0-3.7,2.3-3.5,2.9s4.8-.9,4.8-.9c0,0-.9,2.2-1.7,3.2,0,0,.9.5,2.7-1.5,1.8-2,4.7-1.4,7-3.1,2.3-1.8-1.4-5.7-3.5-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.5,98.5s-5.7,3.7-9.3,12.6c-3.6,8.9-14.9,25.6-17.6,29.9-2.7,4.3-.8,27.8-.8,27.8,0,0-3.3-14.2-4.8-19.8-1.5-5.6,4.8-19.3,5.7-20s5.8.6,4.8-5,12-29.6,15.4-30.2c0,0,5.5,1,6.5,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.9,99.7c-.1.2-.2.4-.3.6-1.3,1.9-3.7,3.3-3.7,3.3,0,0-4.3,6.1-4.4,6.8,0,.6-7.5,6-10.9,5.9h0c-.5,0-.8-.1-1.1-.4-2-1.9,6.7-17.5,8.6-20.9.1-.2.2-.4.3-.5,0,0,0-.1,0-.1,0,0-1.5-5.7,4.9-4.6,5.3.9,6.4,5.1,6.9,7.9.1.7,0,1.4-.4,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.6,105.6c4.4-5.8,19.9-17,28-20.3l2,3.8s-15.7,13.8-19.4,19.7-8.3,8.4-12.6,6.4c-4.4-2,1.1-8.4,2.1-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.4,98.5l-.8,1-.4.5-1.4,1.6s-3.5,4.2-3.3,5.9c.1,1.2-6.6,6.6-11.8,8.9-2.1.9-4,1.3-5.1.7-3.8-2.2-2.9-8.7-.8-13.1,1.9-3.9,10.1-8.8,12.2-10.1.3-.2.4-.3.5-.3h0s.8-3.1.8-3.1c0,0,2.9-1.7,5.1-.7,0,0-5,.2-4.2,2.2.8,2,7.8,6.5,9.2,6.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.5,82.5c-5,2.1-4.3,6.6-8.9,6.6s-3.2-3.3-3.2-3.3c1.3-2.8,2.1-7.5,2.3-9.8.2-2.3.9-1.4.9-1.4,0-.2,0-.4,0-.6,0-1.5-.3-2.6.7-2,1.1.7,1.5,5,1.5,5,.9-6.3-.5-7.2.6-6.7,1.5.8,1.5,6.3,1.5,6.5,1.2-3.7.9-5.7,1.7-4.9s-.4,7.6-.9,10c-.1.6-.2.9-.2.9,4-2,4-.4,4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M178.7,82c-.1.6-.2.9-.2.9,0,0-1.8-.2-3.2,1.8,0,0,.4-2.7,3.4-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M173.9,79.1c0-.5.3-3.6-.3-4.5,0-.2,0-.4,0-.6,1.2.2.4,4.5.3,5.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177,105.6s3.4-9.2,4.5-11.3c1.1-2.1,6.7-1.7,11-.9,4.3.8,5.1,6.5,5.1,6.5,0,0-13-6.1-20.6,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.9,87.5s-4.1,7.5-4,15.9c0,0-6.6,4.5-9-1.1,0,0,2.5-7.4,1.3-17.3-.8-6.7,11.7,2.6,11.7,2.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.9,77.1s-1.2-4.3-3.4-1.3c-2.5,3.5,0,6.9,1.4,6.1,1.3-.8,2-4.8,2-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.1,88.1s4.3-1.2,2.8,2.2c-1.7,4-5.9,3.5-5.9,2,0-1.6,3.1-4.2,3.1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.7,95.9c-6.1-3.4-7.3-9.4-.6-21.4,3.5-6.2,8.8-8.2,15.6-4.4,6.9,3.9,7.6,9.3,4.1,15.5-7.3,12.9-12.9,13.8-19.2,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M202.4,88.7c-.2.7-1.1,1-2,.7s-1.3-1.1-1.1-1.8c.2-.7,1.1-1,2-.7.8.3,1.3,1.1,1.1,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.6,82c-.4.6-1.3.7-2.1.2-.8-.5-1-1.4-.7-2,.4-.6,1.3-.7,2.1-.2.8.5,1,1.4.7,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M203.3,81c-.2,0-.3-.1-.3-.3-.3-1.4-1.9-2.2-1.9-2.2-.2,0-.2-.3-.1-.5,0-.2.3-.2.5-.1,0,0,1.8,1,2.2,2.6,0,.2,0,.4-.3.4,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M194.9,75c0,0-.1,0-.2,0,0,0-1.5-.9-2.8-.5-.2,0-.4,0-.4-.2,0-.2,0-.4.2-.4,1.6-.5,3.3.5,3.4.5.2.1.2.3.1.5,0,.1-.2.2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M200.8,83.9c-.4.8-1.1,1.2-1.5.9-.4-.2-.4-1,0-1.8s1.1-1.2,1.5-.9c.4.2.4,1,0,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M192.2,79.3c-.4.8-1.1,1.2-1.5.9-.4-.2-.4-1,0-1.8s1.1-1.2,1.5-.9.4,1,0,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M189.2,87.1s3.5,2.7,6.1,2.8c0,0-2.7,2.2-4.6.8-1.9-1.4-1.4-3.5-1.4-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M198.9,82.3s1.6-1.6,2.3-1c.7.5.3,2.5.3,2.5h1.4s-1.2-.4-1.2-.4c0,0,.4-2-.4-2.4-1-.6-2.5,1.4-2.5,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M192.8,79.2s.5-2.2-.3-2.5-2.3,1-2.3,1l-.8-1.2,1,.8s1.5-1.4,2.2-.9c1,.6.1,2.8.1,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M204.4,72.7s-2.2-3.1-5.2-.6c-3,2.4-9.9,6.3-13.2,5-3.4-1.3,7.4-15.6,16.7-11.4,9.3,4.2,8.5,17.9,4.6,22.2s-2,.3-2,.3c0,0,.3-6.2,1.6-10.2,1.3-4.1-2.3-5.2-2.3-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M194,85.7c-.2,0-.3,0-.5,0l.2-.7c.6.2.9-.1,1.1-.4.2-.4.2-.8,0-1,0-.1-.3,0-.5,0l-.4-.7c.8-.4,1.2,0,1.4.1.4.4.5,1.3,0,1.9-.3.5-.8.8-1.4.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238.9,138.4c-.4,5.4-13.7,22.9-15.9,23.5-.6.2-1.2.5-1.7.9-.2.2-.5.3-.7.5-1.3,1-2.2,2.2-2.2,2.2-3.9-.3-14.8-5.3-11.3-6.4.2,0,.4-.2.7-.4.1-.1.3-.2.5-.4,4.1-3.5,12.2-17.5,12.2-18.6,0-1.2,1.4-1.4,1.4-1.4,0,0-7.6-11.1-12-12.5s-6.6-6.7-6.6-6.7c-4.3-18.4,8.3-15.5,8.3-15.5,9.3,5.5,27.7,29.2,27.3,34.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M221.3,162.8c-.2.2-.5.3-.7.5-6-.4-11-3.3-12.8-4.6.1-.1.3-.2.5-.4,2,1.3,7.1,4.2,13,4.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.9,99.7c-.1.2-.2.4-.3.6-.9,0-1.7-.1-2.4-.3-3.9-.8-7-3-9-4.9-.5-.4-.9-.9-1.2-1.3.3-.2.4-.3.5-.3.3.3.6.7,1,1,2,1.9,5.1,4.2,9.1,4.9.8.1,1.5.2,2.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M225.5,178.8c-1.8,3.1-5.2,6.8-11.1,7.8-.1-.2-.2-.3-.3-.5,6.1-.9,9.4-4.9,11.2-7.9,0,.2.2.4.3.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M124.4,279.8s-1.4,1.4-2.8,3.9.1,4.8-6.8,10.6c0,0-14.1-8.2-20.5-18.9,0,0,.1-3,3.2-3.7,1.7-.4,6.2,1.8,10.6,2.6.6.1,1.2.2,1.9.3.8,0,1.5,0,2.2,0,.7,0,1.3-.2,1.9-.5h0c1.5-.6,2.7-1.8,3.3-3.9,0,0,3.7,2.1,1.2,5.7,0,0,4.4-1.9,5.8,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.8,294.3s-14.1-8.2-20.5-18.9c0,0,2.4-.5,4.3,3,2,3.5,17.3,11.5,16.1,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.8,277.7c-1.1,1.8-1.1-1.5-2.6-3.1.7,0,1.3-.2,1.9-.5h0c.7.7,1.6,2.1.7,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M110.4,277.8c-1.2,1.1-1.6-1.8-2.3-3.4.6.1,1.2.2,1.9.3.7,1,1.4,2.3.5,3.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M211.1,316.4h-19.9s-.8-2.8,0-5.8c.4-1.3,2.4-2.6,4.3-4.3.5-.5,1-1,1.5-1.5.4-.4.7-.9,1-1.5.4-.6.7-1.3.8-2.1.3-1.5.2-3.3-.7-5.4,0,0,6.8-1.4,9.2,2.3,0,0,.2-1.7,2.4-.6,0,0-.3,3.4.1,6.3.4,2.9,3.1,3.7,1.2,12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.9,304.4c-.2.2-.4.3-.7.3s-.4,0-.6-.2c-1-.8-3.3-2.1-6.6-1.2.4-.6.7-1.3.8-2.1,1.3-.5,3.8-.8,6.9,1.9.4.3.5.9.1,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M204.3,307.7v.2c-.4.4-.9.5-1.3.3-1.4-.8-4.4-2.3-7.4-1.9.5-.5,1-1,1.5-1.5,1.5-.3,4.3-.5,7,1.7.4.3.5.8.2,1.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomecoverhero);
export default __webpack_public_path__ + "static/media/homecoverhero.212840331e713b5000a3154de8f09f83.svg";
export { ForwardRef as ReactComponent };